import update from 'immutability-helper'
import MediaQueryConstants from './MediaQueryConstants'
import {createReducer} from "utils/ReduxUtils"
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  screenSize: {
    isMobile: false,
    hasMobileMenu: false,
    extraLarge: false,
    breakpoint: ''
  }
}

const MediaQueryActionHandlers = {
  [MediaQueryConstants.ActionConstants.MATCH_MEDIA]: (state, action) => update(state, {
    screenSize: {
      [action.payload.name]: { $set: action.payload.match }
    }
  })
}

export default createReducer(initialState, MediaQueryActionHandlers)



// WEBPACK FOOTER //
// ./src/redux-modules/media-query/MediaQueryReducer.js